import { render, staticRenderFns } from "./ro_sidebar.vue?vue&type=template&id=65120f11&"
import script from "./ro_sidebar.vue?vue&type=script&lang=js&"
export * from "./ro_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./ro_sidebar.vue?vue&type=style&index=0&id=65120f11&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports